module.exports = __webpack_public_path__ + "static/media/event25.5959f93a.jpeg";